import React,{useState} from 'react';
import AuthService from "../../../Services/auth/authAPI";
import {Link, useNavigate, useParams} from "react-router-dom";

const StationSidBar = ({pathname}) => {

    const id = useParams();

    const navigate = useNavigate();
    const [me, setMe] = useState(AuthService.getAuthenticatedUser());

    const handleLogout = () => {
        AuthService.logout();
        navigate("/login")
    };

    return (
        <aside id="sidebar" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">

                <li className="nav-item">
                    <Link className={pathname === '/station/dashboard' ? 'nav-link ' : 'nav-link collapsed'} to="/station/dashboard">
                        <i className="bi bi-grid"></i>
                        <span>Tableau de bord</span>
                    </Link>
                </li>

                <li className="nav-heading">Vente des billets</li>

                <li className="nav-item">
                    <Link className={pathname === '/station/newConsumption' ? 'nav-link ' : 'nav-link collapsed'} to="/station/newConsumption">
                        <i className="bi bi-pass-fill"></i>
                        <span>Ajouter</span>
                    </Link>
                </li>

                <li className="nav-heading">RAPPORT</li>

                <li className="nav-item">
                    <Link className={pathname === '/station/dailyConsumption' ? 'nav-link ' : 'nav-link collapsed'} to="/station/dailyConsumption">
                        <i className="bi bi-play-fill"></i>
                        <span>Aujourd'hui</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/station/mounthlyConsumptions' ? 'nav-link ' : 'nav-link collapsed'} to="/station/mounthlyConsumptions">
                        <i className="bi bi-play-fill"></i>
                        <span>Rapports 30 derniers jours</span>
                    </Link>
                </li>

                <li className="nav-item">
                    <Link className={pathname === '/station/allConsumption' ? 'nav-link ' : 'nav-link collapsed'} to="/station/allConsumption">
                        <i className="bi bi-play-fill"></i>
                        <span>Tous les Rapports</span>
                    </Link>
                </li>

            </ul>

            <div className="fixed-bottom mx-4 my-3">
                <button className="btn btn-danger" onClick={handleLogout}>
                    <i className="bi bi-box-arrow-left"></i>
                    <span> Se deconnecter</span>
                </button>
            </div>

        </aside>
    );
};

export default StationSidBar;